import PropTypes from 'prop-types'

import { Icon } from '../display/icon'

const CategoryIcon = ({ label = 'Category', ...rest }) => {
  return (
    <Icon
      label={label}
      {...rest}
      dangerouslySetGlyph={`<svg data-name="Layer 1" viewBox="0 0 300 300"><path d="M179.7 74.4a22.1 22.1 0 0 0-22.1-21.1H84.4v139.6H275V74.4z" style="fill:#fff"/><path d="M275 197.9H84.4a5 5 0 0 1-5-5V53.3a5 5 0 0 1 5-5h73.2A27 27 0 0 1 184 69.4h91a5.1 5.1 0 0 1 5 5v118.5a5 5 0 0 1-5 5zm-185.6-10H270V79.4h-90.3a5 5 0 0 1-5-4.8 17.1 17.1 0 0 0-17.1-16.3H89.4z" style="fill:#1d1d1b"/><path d="M150.5 102.6a22.1 22.1 0 0 0-22.1-21.1H55.2v139.6h190.6V102.6z" style="fill:#fff"/><path d="M245.8 226.1H55.2a5 5 0 0 1-5-5V81.5a5 5 0 0 1 5-5h73.2a27 27 0 0 1 26.4 21.1h91a5.1 5.1 0 0 1 5 5v118.5a5 5 0 0 1-5 5zm-185.6-10h180.6V107.6h-90.3a5 5 0 0 1-5-4.7 17.1 17.1 0 0 0-17.1-16.4H60.2z" style="fill:#1d1d1b"/><path d="M120.3 128.2a22.1 22.1 0 0 0-22.1-21.1H25v139.6h190.6V128.2z" style="fill:#f4c223"/><path d="M215.6 251.7H25a5 5 0 0 1-5-5V107.1a5 5 0 0 1 5-5h73.2a27 27 0 0 1 26.4 21.1h91a5.1 5.1 0 0 1 5 5v118.5a5 5 0 0 1-5 5zM30 241.7h180.6V133.2h-90.3a5 5 0 0 1-5-4.7 17.1 17.1 0 0 0-17.1-16.4H30z" style="fill:#1d1d1b"/><path d="M199.4 218.4a2.3 2.3 0 0 0-2.2 2.3v8.1h-8.3a2.3 2.3 0 1 0 0 4.5h10.5a2.3 2.3 0 0 0 2.3-2.3v-10.3a2.3 2.3 0 0 0-2.3-2.3zm-2.2-7.3V209a2.3 2.3 0 1 1 4.5 0v2.1a2.2 2.2 0 0 1-2.3 2.2 2.2 2.2 0 0 1-2.2-2.2z" style="fill:#1d1d1b"/></svg>`}
    />
  )
}

CategoryIcon.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large'])
}

export { CategoryIcon }
